import React, { useState, useEffect, useCallback } from "react";
import { Table, Button, Typography, Select, Row, Col } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import SubCategoryFormModal from "./components/StoriesFormModal";
import SubCategoriesColumn from "./components/StoriesColumn";
import AdvancedSearchForm from "../../../common/SearchForm";

const { Title, Text } = Typography;
const { Option } = Select;

function CategoriesManagement(props) {
  const [searchOption, setSearchOption] = useState(false);
  const [infoModalVisible, setStoriesModalVisible] = useState(false);
  const [currentData, setCurrentData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const hideModal = () => {
    setStoriesModalVisible(false);
  };
  const onAddStories = async (payloadObj) => {
    hideModal();
    await props.addCatalogSurgeryStory(payloadObj);
    await props.getAllCatalogSurgeryStories(undefined, 20, currentPage);
  };
  const onUpdateStories = async (payloadObj) => {
    await props.updateCatalogSurgeryStory(payloadObj);
    await props.getAllCatalogSurgeryStories(undefined, 20, currentPage);
  };
  const onDeleteStories = async (payloadObj) => {
    await props.deleteCatalogSurgeryStory(payloadObj);
    await props.getAllCatalogSurgeryStories(undefined, 20, currentPage);
  };

  const onStoriesSubmit = async (data) => {
    await onAddStories({
      surgery_story: { ...data, surgery_id: currentData.id },
    });
    hideModal();
  };

  const renderData = useCallback(
    (currentPage) => {
      props.getAllCatalogSurgeryStories(undefined, 20, currentPage);
    },
    [
      props.getAllCatalogSurgeryStories,
      props.addCatalogSurgeryStoryContent,
      props.deleteCatalogSurgeryStoryContent,
      props.updateCategorySuccess,
      props.deletedTourStories,
    ]
  );

  useEffect(() => {
    renderData(currentPage);
  }, [renderData, currentPage]);

  const columns = [
    {
      title: "Title",
      key: "title",
      dataIndex: "title",
      render: (_, columnData) => (
        <Row className="name-details-row">
          <Col span={20}>
            <Text>
              <div>{columnData.title}</div>
            </Text>
            {columnData.status ? (
              <span className="activate">Active</span>
            ) : (
              <span className="inActivateNotverified">Blocked</span>
            )}
          </Col>
        </Row>
      ),
    },
    {
      title: "Stories",
      key: "subCategory",
      width: "50%",
      render: (_, columnData) => (
        <SubCategoriesColumn
          columnData={columnData}
          updateStories={onUpdateStories}
          deleteStories={onDeleteStories}
        />
      ),
    },
    {
      title: "",
      key: "actions",
      render: (_, columnData) => (
        <Button
          icon={<PlusOutlined />}
          type="primary"
          onClick={() => {
            setStoriesModalVisible(true);
            setCurrentData(columnData);
          }}
        >
          ADD STORY
        </Button>
      ),
    },
  ];
  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join("&");
    props.getAllCatalogSurgeryStories(queryString, 20, currentPage);
  };
  const toggleSearch = () => {
    setSearchOption(!searchOption);
  };

  return (
    <div>
      <SubCategoryFormModal
        onSubmit={onStoriesSubmit}
        onCancel={hideModal}
        visible={infoModalVisible}
        title={`Add Surgery Stories`}
        submitText="Add Stories"
      />
      <Row gutter={[0, 16]}>
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            Surgery - Stories
          </Title>
        </Col>
        <Col className="gutter-row" span={9} offset={0}></Col>
        <Col className="gutter-row header-buttons" span={3} offset={0}>
          <Button
            className={`${
              searchOption === true ? "search-open" : "search-close"
            } search-toggle-button`}
            onClick={() => toggleSearch()}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
      </Row>
      {searchOption === true ? (
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Health Products"
          formItems={[
            {
              key: "q[city_cont]",
              label: "City",
            },
            {
              key: "q[country_cont]",
              label: "Country",
            },
            {
              key: "q[status_eq]",
              label: "Status",
              Component: (
                <Select placeholder="Status - Active / Blocked">
                  <Option value>Active</Option>
                  <Option value={false}>Blocked</Option>
                </Select>
              ),
            },
          ]}
        />
      ) : (
        ""
      )}
      <Table
        className="list_table"
        dataSource={props.catalogStories ? props.catalogStories.data : null}
        pagination={{
          pageSize: 20,
          total: props.catalogStories?.total_count,
          showSizeChanger: false,
        }}
        columns={columns}
        scroll={{ x: 800 }}
        rowKey="id"
        onChange={(e) => {
          setCurrentPage(e.current);
        }}
      />
    </div>
  );
}

export default CategoriesManagement;
